import React, { useEffect, useState } from "react";
import "./BUFilter.scss";
import { Button, Popover, Stack, Box, Tooltip } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
// import UserEmailDropdown from "../../../utility/userEmailDropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  setSubAgentName,
  setBusinessUnit,
  setSelectedEmails,
} from "../../../redux/slices/filtersSlice";
import BusinessUnitDropdown from "./DropDowns/BusinessUnitDropdown/BusinessUnitDropdown";
import IndicationsDropdown from "./DropDowns/IndicationsDropdown/IndicationsDropdown";
import UsersDropdown from "./DropDowns/UsersDropdown/UsersDropdown";
import { fetchUniqueUsersList } from "../../../redux/slices/dashboardSlice";
import { PERIOD_TO_DATA_BASIS } from "../../../features/dashboard/hooks/useDashboardData";

const buildPayload = (filters, tempBusinessUnit, tempSubAgentName) => {
  const { userGroup, period, startDate, endDate } = filters;

  const basePayload = {
    sub_agent_name: tempSubAgentName,
    business_unit: tempBusinessUnit,
    user_group: userGroup,
  };

  // Predefined period (lastWeek, lastMonth etc.)
  if (PERIOD_TO_DATA_BASIS[period]) {
    return {
      ...basePayload,
      start_date: null,
      end_date: null,
      data_basis: PERIOD_TO_DATA_BASIS[period],
    };
  }

  // Custom date range
  return {
    ...basePayload,
    start_date: startDate,
    end_date: endDate,
  };
};

const BUFilter = () => {
  const dispatch = useDispatch();

  const {
    subAgentName,
    businessUnit,
    selectedEmails,
    period,
    startDate,
    endDate,
    userGroup,
  } = useSelector((s) => s.filters);

  //   const [tempAgentName, setTempAgentName] = useState(agentName);
  const [tempSubAgentName, setTempSubAgentName] = useState(subAgentName);
  const [tempEmails, setTempEmails] = useState(selectedEmails);
  const [tempBusinessUnit, setTempBusinessUnit] = useState(businessUnit);

  const [anchorEl, setAnchorEl] = useState(null);
  const openPop = Boolean(anchorEl);

  const handleOpen = (e) => {
    // Reset temps to current Redux state when opening
    setTempBusinessUnit(businessUnit);

    setTempSubAgentName(subAgentName);
    setTempEmails(selectedEmails);
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleSubmitFilter = () => {
    dispatch(setBusinessUnit(tempBusinessUnit));
    dispatch(setSubAgentName(tempSubAgentName));
    dispatch(setSelectedEmails(tempEmails));
    handleClose();
  };

  useEffect(() => {
    const payload = buildPayload(
      { period, startDate, endDate, userGroup },
      tempBusinessUnit,
      tempSubAgentName,
    );

    dispatch(fetchUniqueUsersList(payload));
    setTempEmails([]);
  }, [
    tempBusinessUnit,
    tempSubAgentName,
    period,
    startDate,
    endDate,
    userGroup,
    dispatch,
  ]);

  return (
    <div className="filter-wrapper">
      <Tooltip title="Open Filters" arrow>
        <Button
          variant="outlined"
          color="inherit"
          onClick={handleOpen}
          startIcon={<FilterListIcon sx={{ fontSize: 18 }} />}
          className="filter-button"
        >
          Filter
        </Button>
      </Tooltip>

      <Popover
        open={openPop}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { sx: { p: 2, minWidth: 240, borderRadius: "6px" } },
        }}
      >
        <Stack spacing={2} className="filter-content">
          <BusinessUnitDropdown
            className="table-dropdown-container"
            value={tempBusinessUnit}
            onChange={setTempBusinessUnit}
            setTempSubAgentName={setTempSubAgentName}
          />
          <IndicationsDropdown
            businessUnit={tempBusinessUnit}
            selectedValues={tempSubAgentName}
            onSelectionChange={setTempSubAgentName}
            disabled={tempBusinessUnit === "Global"}
          />
          <UsersDropdown
            selectedEmails={tempEmails}
            onSelectionChange={setTempEmails}
          />
          <Box display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={handleClose} className="cancel-btn">
              Cancel
            </Button>
            <Button
              onClick={handleSubmitFilter}
              variant="contained"
              className="apply-btn"
            >
              Apply
            </Button>
          </Box>
        </Stack>
      </Popover>
    </div>
  );
};

export default BUFilter;
